import { defineMetrics } from "../types.js"

export const submissionsMetrics = defineMetrics([
  {
    id: "tracking_created_by",
    name: "User Who Created Tracking",
    description: "User responsible for creating a Tracking.",
    logic: "Retrieve creator ID for each Tracking.",
    source: "tracking.creator — there is no createdBy field",
    domain: "submissions",
    srvModule: "submissions",
    priority: "must",
    valueType: "count",
    dims: ["user"],
    rollup: "sum",
    defaultWidget: "table",
    altWidgets: ["hbar", "bar"],
    coveredByV1: false,
    sensitive: true,
    xlsxRow: 42,
  },
  {
    id: "total_trackings",
    name: "Total Trackings",
    description: "Total number of Trackings.",
    logic: "Count Tracking records.",
    source: "tracking.countDocuments()",
    domain: "submissions",
    srvModule: "submissions",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["line", "bar"],
    coveredByV1: true,
    xlsxRow: 43,
  },
  {
    id: "trackings_added",
    name: "Trackings Added",
    description: "Number of Trackings created during the reporting period.",
    logic: "Count new Trackings within the selected period.",
    source: "tracking.createdAt, bucketed by period",
    domain: "submissions",
    srvModule: "submissions",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "sum",
    defaultWidget: "bar",
    altWidgets: ["line", "stat-tile"],
    coveredByV1: true,
    xlsxRow: 44,
  },
  {
    id: "trackings_cloned",
    name: "Trackings Cloned",
    description: "Number of cloned Trackings.",
    logic: "Count cloned Tracking records.",
    source: "tracking.cloneRef exists and is non-null — there is no boolean clone flag",
    domain: "submissions",
    srvModule: "submissions",
    priority: "must",
    valueType: "count",
    dims: [],
    rollup: "last",
    defaultWidget: "stat-tile",
    altWidgets: ["bar", "line"],
    coveredByV1: true,
    xlsxRow: 46,
  },
  {
    id: "tracking_status_breakdown",
    name: "Tracking Status Breakdown",
    description: "Number of Trackings grouped by status.",
    logic: "Group Trackings by current status and count each group.",
    source: "tracking.status, a free-form string rather than an enum",
    domain: "submissions",
    srvModule: "submissions",
    priority: "must",
    valueType: "count",
    dims: ["class"],
    rollup: "last",
    defaultWidget: "stacked-bar",
    altWidgets: ["pie", "hbar", "table"],
    coveredByV1: false,
    xlsxRow: 47,
  },
])
